var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.closed)?_c('div',{class:_vm.classes},[_c('p',[_vm._t("default")],2),_vm._v(" "),(_vm.dismissible)?_c('button',{staticClass:"notice-dismiss",attrs:{"type":"button"},on:{"click":_vm.close}},[_c('span',{staticClass:"screen-reader-text"},[_vm._v("Dismiss this notice.")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3835a44d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-wp-notice/src/components/wp-notice/wp-notice.vue
// module id = null
// module chunks = 